import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

interface BasicDataHelpModalProps {
  onClose: () => void;
  isOpen: boolean;
}

const BasicDataHelpModal: FC<BasicDataHelpModalProps> = ({
  onClose,
  isOpen,
}) => {
  const { t } = useTranslation('planAction');

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle
        alignItems="center"
        display="flex"
        justifyContent="space-between"
      >
        <Typography variant="h4">
          {t('ActionPlan.BasicDataHelp.Headline')}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="primary" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            pt: 3,
          }}
        >
          {t('ActionPlan.BasicDataHelp.Text')}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BasicDataHelpModal;
